module.exports = __webpack_public_path__ + "static/img/figma-multi.1d93ea59.svg";